var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_12495_320995",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6L0.5 4.5L5 0L9.5 4.5L8 6L5 3L2 6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5L-1.62132 2.37868L-3.74264 4.5L-1.62132 6.62132L0.5 4.5ZM2 6L-0.12132 8.12132L2 10.2426L4.12132 8.12132L2 6ZM5 3L7.12132 0.87868L5 -1.24264L2.87868 0.87868L5 3ZM8 6L5.87868 8.12132L8 10.2426L10.1213 8.12132L8 6ZM9.5 4.5L11.6213 6.62132L13.7426 4.5L11.6213 2.37868L9.5 4.5ZM5 0L7.12132 -2.12132L5 -4.24264L2.87868 -2.12132L5 0ZM-1.62132 6.62132L-0.12132 8.12132L4.12132 3.87868L2.62132 2.37868L-1.62132 6.62132ZM4.12132 8.12132L7.12132 5.12132L2.87868 0.87868L-0.12132 3.87868L4.12132 8.12132ZM2.87868 5.12132L5.87868 8.12132L10.1213 3.87868L7.12132 0.87868L2.87868 5.12132ZM10.1213 8.12132L11.6213 6.62132L7.37868 2.37868L5.87868 3.87868L10.1213 8.12132ZM11.6213 2.37868L7.12132 -2.12132L2.87868 2.12132L7.37868 6.62132L11.6213 2.37868ZM2.87868 -2.12132L-1.62132 2.37868L2.62132 6.62132L7.12132 2.12132L2.87868 -2.12132Z",
    fill: "inherit",
    mask: "url(#path-1-inside-1_12495_320995)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.fb1d661bc7defc01300560de28dbc6ff.svg";
export { ForwardRef as ReactComponent };